"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUrlSafe = void 0;
function toUrlSafe(src) {
    while (src.indexOf('/') >= 0) {
        src = src.replace('/', '_');
    }
    while (src.indexOf('+') >= 0) {
        src = src.replace('+', '-');
    }
    while (src.indexOf('=') >= 0) {
        src = src.replace('=', '');
    }
    return src;
}
exports.toUrlSafe = toUrlSafe;
